// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WNmb","left":"styles_left__2OFLw","right":"styles_right__MV8Od","alert":"styles_alert__a6B3r"};